module.exports = __webpack_public_path__ + "img/26.0153d47b.jpg";